module.exports = __webpack_public_path__ + "static/media/camera.b2a0d108.svg";